import { Navigate, Outlet } from "react-router-dom";
import jwt_decode from "jwt-decode";

export const AuthRoutes = () => {
  const token = localStorage.getItem("token");
  if (token) {
    try {
      jwt_decode(token);
      // Si déjà connecté, aller direct au dashboard
      return <Navigate to="/dashboard" replace />;
    } catch {
      localStorage.removeItem("token");
    }
  }
  return <Outlet />;
};